type Props = {
  title: string;
  subtitle?: string;
  loading?: boolean;
  actionLabel?: string;
  onAction?: () => void;
};

export function InfoScreenState({
  title,
  subtitle,
  loading = false,
  actionLabel,
  onAction,
}: Props) {
  return (
    <div className="info-screen-state" role="status">
      {loading ? <div className="info-screen-state__spinner" aria-hidden /> : null}
      <h2 className="info-screen-state__title">{title}</h2>
      {subtitle ? <p className="info-screen-state__subtitle">{subtitle}</p> : null}
      {actionLabel && onAction ? (
        <button type="button" className="info-screen-state__action" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
